import * as React from "react";
import Template from "@/module/data/texts/textTemplateModule";

const jaText = {
  shareText: <>公式SNS</>,
  landscape: "スマートフォンを縦にしてご覧ください。",
};

const enText = {
  shareText: <>OFFICIAL SNS</>,
  landscape: "Please rotate your device.",
};

export default Template.selectLanguage(jaText, enText);
